import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles((theme: Theme) => ({
  activeState: {
    backgroundColor: '#00000010'
  },
  menuRoot: {
    marginTop: theme.spacing(0.5)
  },
  root: {
    '& .MuiDataGrid-row.Mui-selected': {
      '&:hover': {
        backgroundColor: '#00000003'
      },
      backgroundColor: 'transparent',
    },
    height: 736,
    width: '100%'
  },
  selectedResultsDisplay: {
    color: theme.palette.grey[600]
  },
  tableMenuButton: {
    marginLeft: theme.spacing(0.5)
  }
}));

export default styles;